module.exports = __webpack_public_path__ + "img/chat-square-quote.279afaa3.svg";